import { enUS, fr, de, pt, es } from 'date-fns/locale';
import type { Locale } from 'date-fns';
import type { SupportedLanguage } from './languageSettings';

/**
 * Returns the date-fns locale object corresponding to the app's current language setting.
 */
export function getDateLocale(language: SupportedLanguage): Locale {
  switch (language) {
    case 'French':
      return fr;
    case 'German':
      return de;
    case 'Portuguese':
      return pt;
    case 'Spanish':
      return es;
    case 'English':
    default:
      return enUS;
  }
}
